var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyEmailHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 30,
    width: 30,
    height: 30,
    rx: 15,
    transform: "rotate(-90 0 30)",
    fill: "#1e88e5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 7.96875H12.1875C11.9637 7.96875 11.7491 8.05764 11.5909 8.21588C11.4326 8.37411 11.3438 8.58872 11.3438 8.8125V11.3438H8.8125C8.58872 11.3438 8.37411 11.4326 8.21588 11.5909C8.05764 11.7491 7.96875 11.9637 7.96875 12.1875V21.1875C7.96875 21.4113 8.05764 21.6259 8.21588 21.7841C8.37411 21.9424 8.58872 22.0312 8.8125 22.0312H17.8125C18.0363 22.0312 18.2509 21.9424 18.4091 21.7841C18.5674 21.6259 18.6562 21.4113 18.6562 21.1875V18.6562H21.1875C21.4113 18.6562 21.6259 18.5674 21.7841 18.4091C21.9424 18.2509 22.0312 18.0363 22.0312 17.8125V8.8125C22.0312 8.58872 21.9424 8.37411 21.7841 8.21588C21.6259 8.05764 21.4113 7.96875 21.1875 7.96875ZM16.9688 20.3438H9.65625V13.0312H16.9688V20.3438ZM20.3438 16.9688H18.6562V12.1875C18.6562 11.9637 18.5674 11.7491 18.4091 11.5909C18.2509 11.4326 18.0363 11.3438 17.8125 11.3438H13.0312V9.65625H20.3438V16.9688Z",
    fill: "#ffffff",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyEmailHover);
export default __webpack_public_path__ + "static/media/copyEmail Hover.f3fd8e1c0f3326ce2c67b8e2a57523e6.svg";
export { ForwardRef as ReactComponent };